module.exports = __webpack_public_path__ + "static/Vedanta_SDR_2019-d48002e623c9a6d14bd3bf9c99c569e1.pdf";